import dashboardReducer from './dashboardReducer';

export default dashboardReducer;
